import React from 'react'

const ContentSection = () => {
    return (
        <section className='px-4 py-10'>
            <div className='grid grid-cols-1 md:grid-cols-2 gap-5 max-w-7xl w-full mx-auto'>
                <h1 className="text-3xl md:text-4xl font-bold text-headings max-w-[400px] w-full">
                    Fast, Reliable Delivery for Your Business
                </h1>

                <p className='text-light_black text-sm md:text-lg'>
                    Whether you're a small retailer, a trade supplier, or a national enterprise, Tuber is your dedicated partner
                    for on-demand, same-day, and scheduled commercial deliveries. Our platform makes it easier than ever
                    to get your goods to customers quickly, efficiently, and without hassle.
                </p>
            </div>
        </section>
    )
}

export default ContentSection